import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutRateExceptionDuplication extends Layout {
	sourceRateExceptions: DataSource;
	tableRateExceptions: Table;
}
